import isEmpty from 'lodash/isEmpty';

import { useRequestProcessing } from '@gogame/query';
import {
  uploadCategories,
  checkUploadCategories,
} from 'scenes/Influencers/InfluencersChannels/sources/categories';

import { uploadCategories as uploadCategoriesKey } from '../queryKeyFactory';
import { messagesCategories } from '../messages';

export const useUploadCategories = () => {
  const importMessage = messagesCategories.import();
  return useRequestProcessing(
    uploadCategoriesKey(),
    uploadCategories,
    checkUploadCategories,
    {
      isCompleted: (result) => result?.percentCompleted === 100,
      isFailed: (result) => !isEmpty(result?.errors),
      getCompletedMessage: () => importMessage.completed(),
      getFailedMessage: () => importMessage.failed(),
      getProcessMessage: (result) =>
        importMessage.processing(result?.percentCompleted),
    }
  );
};
